import { render, staticRenderFns } from "./TimeDisplay.vue?vue&type=template&id=18c01599&scoped=true"
import script from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeDisplay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TimeDisplay.vue?vue&type=style&index=0&id=18c01599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c01599",
  null
  
)

export default component.exports